// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"IdInformation_infoWrapper__36qM6","info":"IdInformation_info__1_67S","job":"IdInformation_job__3U2ER","loan":"IdInformation_loan__3cIKN"};